import { AppHeader, AppSegment } from 'client/ui-building-blocks'
import { Theme } from 'client/utils'

type Props = {
  theme: Theme
}

const HeaderPreview = ({ theme }: Props) => {
  return (
    <>
      <AppSegment headerProps={{ text: 'Size', marginBottom: 'small' }}>
        <AppHeader
          text={'This is a small size text. '.repeat(25)}
          size="small"
          marginBottom="xsmall"
        />
        <AppHeader
          text={'This is a medium size text. '.repeat(25)}
          size="medium"
          marginBottom="xsmall"
        />
        <AppHeader
          text={'This is a large size text. '.repeat(25)}
          size="large"
          marginBottom="xsmall"
        />
        <AppHeader
          text={'This is an extra large size text. '.repeat(15)}
          size="xlarge"
          marginBottom="xsmall"
        />
        <AppHeader
          text={'This is a double extra large size text. '.repeat(5)}
          size="xxlarge"
          centered
        />
      </AppSegment>
      <AppSegment headerProps={{ text: 'Loading', marginBottom: 'small' }}>
        <AppHeader
          text="Header text"
          loading
          size="small"
          marginBottom="xsmall"
          theme={theme}
        />
        <AppHeader
          text="Header text"
          loading
          size="medium"
          marginBottom="xsmall"
          theme={theme}
        />
        <AppHeader
          text="Header text"
          loading
          size="large"
          marginBottom="xsmall"
          theme={theme}
        />
      </AppSegment>
    </>
  )
}

export default HeaderPreview
